// import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Dropzone, FileMosaic } from '@dropzone-ui/react';
import toast from 'react-hot-toast';

import {
  AccionDetalle,
  IInitialState,
  // TipoAccionDetalle,
} from '../../Shared/data/FormReducer';
// import { sendFormUsuario } from '../../Services/Form';
// import { Tr4inerContainedButton } from '../../Utils/Button';
import {
  imgManShortV2,
  imgManShortV3,
  imgWomanShortV2,
  imgWomanShortV3,
} from '../../Shared/Images/Cuestionario';
// import LoadingAllScreen from '../../Components/LoadingAllScreen/LoadingAllScreen';

import { IUserFromStorage } from '../../Interfaces/IUser';
// import ToastDisplay from '../../Utils/ToastDisplay';
import { useMediaQuery } from '@mui/material';
import { compressImage, convertHeicToJpeg, isHeic } from '../../Utils/image';

interface Props {
  state: IInitialState;
  dispatch: React.Dispatch<AccionDetalle>;
  files: any[];
  imgBase64Data: string[];
  setFiles: React.Dispatch<React.SetStateAction<any[]>>;
  setImgBase64Data: React.Dispatch<React.SetStateAction<string[]>>;
}

const SubirFotos = ({ state, dispatch, files, setFiles, setImgBase64Data }: Props) => {
  const user: IUserFromStorage = JSON.parse(localStorage.getItem('user'));
  const sexoUser = localStorage.getItem('sexoUser') === 'true';
  const isMobile = useMediaQuery('(max-width:600px)');
  // const [loading, setLoading] = useState<boolean>(false);

  // const navigate = useNavigate();

  const updateFiles = async (incommingFiles: any[]) => {
    let aux: string[] = [];
    const validFiles: any[] = [];

    const toastId = toast.loading("Procesando imágenes...");

    for (const e of incommingFiles) {
      if (e.valid === true) {
        //* Validar peso
        if (e.file.size >= 11 * 1024 * 1024) {
          toast.error(`La imagen "${e.file.name}" es demasiado grande (máx 11 MB).`);
          continue; //* saltamos esta imagen
        }

        try {
          //* Si es HEIC, lo convertimos a JPEG antes de comprimir
          let fileToProcess: File = e.file;
          if (isHeic(e.file)) {
            fileToProcess = await convertHeicToJpeg(e.file);
            e.file = fileToProcess;
            e.name = fileToProcess.name;
            e.type = fileToProcess.type;
            e.size = fileToProcess.size;
          }

          const compressedBase64 = await compressImage(
            fileToProcess,
            0.7,
            1280,
            720,
            'image/webp',
          );
          aux.push(compressedBase64);
          e.base64 = compressedBase64;
          validFiles.push(e);
        } catch (error) {
          console.error(error);
          toast.error(`No se pudo procesar la imagen "${e.file.name}".`);
        }
      }
    }

    toast.dismiss(toastId);

    //* Solo actualizamos el arreglo si hay imágenes válidas
    if (validFiles.length > 0) {
      setImgBase64Data(aux);
      setFiles(validFiles);
    } else {
      //* si todas fueron rechazadas, limpiamos para que Dropzone no muestre nada
      setImgBase64Data([]);
      setFiles([]);
    }
  };

  const onDelete = (id: any) => {
    const updatedFiles = files.filter((x: any) => x.id !== id);
    setFiles(updatedFiles);
    setImgBase64Data(updatedFiles.map((file) => file.base64));
  };

  // function pruebaDeFuego() {
  //   setLoading(true);
  //   setTimeout(() => {
  //     console.log(imgBase64Data);
  //     console.log(props.state);
  //     toast.success('Datos enviados correctamente.');
  //     setLoading(false);
  //     // setIsOpen(false);
  //   }, 3000);
  // }

  // const handleNext = () => {
  //   let err1 = false;

  //   if (user.esReto) {
  //     if (files.filter((e: any) => e.valid === true).length < 4) {
  //       err1 = true;
  //     }
  //   } else {
  //     if (files.filter((e: any) => e.valid === true).length < 3) {
  //       err1 = true;
  //     }
  //   }

  //   if (!err1) {
  //     window.scrollTo(0, 0);
  //     dispatch({
  //       type: TipoAccionDetalle.CHANGE_NFORM,
  //       payload: state.nForm + 1,
  //     });
  //   }
  //   if (err1) {
  //     toast.error(
  //       <ToastDisplay
  //         title={`Hubo un error`}
  //         message={`Tienen que ser mínimo ${user.esReto ? '4' : '3'} imágenes 😢.`}
  //       />,
  //     );
  //     err1 = false;
  //   }
  //   console.log(err1);
  // };

  return (
    <div>
      <div className="my-2 font-bold mt-3">
        <b className={`text-orangeTr4iner text-2xl`}>Sube tus fotos</b>

        <div className="flex flex-col items-center justify-center w-max m-auto text-sm md:text-base">
          {' '}
          {/*This is centered in compilation, idk why it doesn't work in production xd*/}
          <div className="my-3 flex justify-start items-center w-full">
            <span className="h4 font-bold text-left p-0 m-0">1&nbsp;</span>
            Torso descubierto, con SHORT deportivo.
          </div>
          <div className="flex mb-3 justify-start items-center w-full">
            <span className="h4 font-bold p-0 m-0">2&nbsp;</span>
            Tómalas apenas te levantas, frente a una pared clara
          </div>
          <div className="justify-start items-left w-full flex flex-col">
            <div className='w-full flex items-center'>
              <span className="h4 font-bold p-0 m-0">3&nbsp;</span>
              Debes girar lentamente mostrando {user.esReto ? '4' : '3'} posiciones:
            </div>
            <ul className="list-disc ml-4 items-start flex flex-col justify-start text-sm">
              <li>De frente</li>
              <li>De perfil {user.esReto && 'derecho'}</li>
              {user.esReto && (  
                <li>De perfil izquierdo</li>
              )}
              <li>De espalda</li>
            </ul>
          </div>
          {!user.esReto ? (
            <div className="flex justify-start items-center w-full">
              <span className="h4 font-bold p-0 m-0">4&nbsp;</span>
              De cuerpo entero.
            </div>
          ) : (
            <>
              <div className="flex justify-start items-center w-full text-start mb-3">
                <span className="h4 font-bold p-0 m-0">4&nbsp;</span>
                Fotos de cuerpo completo, que se vea desde la {isMobile && <br/>} cabeza hasta los pies.
              </div>
              <div className="flex justify-start items-center w-full mb-3">
                <span className="h4 font-bold p-0 m-0">5&nbsp;</span>
                Las fotos deben ser como el ejemplo mostrado
              </div>
              <div className="flex justify-start items-center w-full mb-3">
                <span className="h4 font-bold p-0 m-0">6&nbsp;</span>
                En cada foto debes sostener un cartel que diga: <br />
                "Reset 8 semanas - Dia 1"
              </div>
            </>
          )}
        </div>
      </div>
      <div className="flex text-center items-center justify-center">
        {user.esReto ? (
          <img src={sexoUser ? imgManShortV3 : imgWomanShortV3} width="280px" alt="img" />
        ) : (
          <img src={sexoUser ? imgManShortV2 : imgWomanShortV2} width="250px" alt="img" />
        )}
      </div>
      <div className="m-1 my-2 font-bold">
        <strong>Nota:</strong> Respetamos tu privacidad. Estas fotos no se divulgarán sin
        tu consentimiento.
      </div>
      <div className="lg:w-[70%] w-[80%] m-auto">
        <Dropzone
          onChange={updateFiles}
          accept="image/*,.heic,.heif"
          maxFiles={user.esReto ? 4 : 3}
          header={false}
          value={files}
          localization={'ES-es'}
          label="Sube tus archivos aquí"
        >
          {files
            .filter((e: any) => e.valid === true)
            .map((file: any) => (
              <FileMosaic {...file} key={file.id} onDelete={onDelete} preview />
            ))}
        </Dropzone>
      </div>
      {/* {user.esReto && (
        <div className="row flex justify-content-center mt-5" style={{ width: '100%' }}>
          <div className="col-6 justify-content-center">
            <Tr4inerContainedButton
              variant="contained"
              size="large"
              sx={{
                textTransform: 'capitalize',
                fontWeight: 'bold',
                fontSize: '1.2rem',
              }}
              onClick={handleNext}
            >
              {`Siguiente`}
            </Tr4inerContainedButton>
          </div>
        </div>
      )} */}
    </div>
  );
};

export default SubirFotos;
